module.exports = __webpack_public_path__ + "img/bi.dfe03d46.svg";